import axios from '@/utils/request'
var Qs = require('qs')
export default {
	ooCheckTimes: [
		{ label: '超过一个月', key: 'one', condition: { exceed: 'one' } },
		{ label: '超过两个月', key: 'two', condition: { exceed: 'two' } },
		{ label: '超过三个月', key: 'three', condition: { exceed: 'three' } },
		{ label: '超过半年', key: 'six', condition: { exceed: 'six' } },
		{ label: '超过一年', key: 'year', condition: { exceed: 'year' } }
	],
	lastInAts: [
		{ label: '超过一个月', key: 'oneIn', condition: { lastInDate: 'one' } },
		{ label: '超过两个月', key: 'twoIn', condition: { lastInDate: 'two' } },
		{ label: '超过三个月', key: 'threeIn', condition: { lastInDate: 'three' } },
		{ label: '超过半年', key: 'sixIn', condition: { lastInDate: 'six' } },
		{ label: '超过一年', key: 'yearIn', condition: { lastInDate: 'year' } }
	],
	lastOutAts: [
		{ label: '超过一个月', key: 'oneOut', condition: { lastOutDate: 'one' } },
		{ label: '超过两个月', key: 'twoOut', condition: { lastOutDate: 'two' } },
		{ label: '超过三个月', key: 'threeOut', condition: { lastOutDate: 'three' } },
		{ label: '超过半年', key: 'sixOut', condition: { lastOutDate: 'six' } },
		{ label: '超过一年', key: 'yearOut', condition: { lastOutDate: 'year' } },
		{ label: '从未出库', key: 'neverOut', condition: { lastOutDate: 'never' } }

	],
	// 2021-01-04
	search(params) {
		return axios.get('/mms/inventories', params)
	},
	// 2021-12-27
	cashSearch(params) {
		return axios.get('/mms/inventories/cash-search', params)
	},
	// 2021-01-04
	findBySerialNoWithWarehouse(params) {
		return axios.get('/mms/inventories/find-by-serial-no-with-warehouse', params)
	},
	// 2021-01-04
	getShelfs(params) {
		return axios.get('/mms/inventories/all-shelf', params)
	},
	// 2021-01-04
	batchCheck(params) {
		return axios.post('/mms/inventories/batch-check', params)
	},
	// 2021-01-04
	exportExcel(params) {
		return axios.get('/mms/inventories/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-01-05
	exportQuickPhoto(params) {
		return axios.get('/mms/inventories/export-quick-photo?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-12-27
	cashSearchExportExcel(params) {
		return axios.get('/mms/inventories/cash-search/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-01-05
	stockIn(params) {
		return axios.put('/mms/inventories/stock-in', params)
	},
	// 2021-01-05
	stockOut(params) {
		return axios.put('/mms/inventories/stock-out', params)
	},
	// 2021-01-05
	update(id, params) {
		return axios.put('/mms/inventories/' + id, params)
	},
	// 2021-01-05
	updatePrice(id, params) {
		return axios.put('/mms/inventories/' + id + '/update-price', params)
	},
	// 2021-01-05
	updateManualLockQuantity(id, params) {
		return axios.put('/mms/inventories/' + id + '/update-manual-lock-quantity ', params)
	},
	// 2021-01-05
	delete(id) {
		return axios.delete('/mms/inventories/' + id)
	},
	// 2021-01-05
	findBySerialNos(params) {
		return axios.put('/mms/inventories/find-by-serial-nos', params)
	},
	// 2021-01-06
	findByMaterialId(materialId) {
		return axios.get('/mms/inventories/find-by-material-id/' + materialId)
	},
	// 2021-01-26
	existMaterialCount() {
		return axios.get('/mms/inventories/exist-material-count')
	},
	// 2021-02-07
	vagueFindBySerialNo(params) {
		return axios.get('/mms/inventories/vague-find-by-serial-no', params)
	},
	// 2021-12-20
	updateRemark(id, params) {
		return axios.put('/mms/inventories/' + id + '/update-remark', params)
	},
	// 2022-01-03
	batchCashReStore(params) {
		return axios.put('/mms/inventories/batch-cash-re-store', params)
	},
}

